export function Muffins() {
    return (
        <span>
            Muffins
        </span>
    )
}